/**
 * Conditional.js - created 2020.09.14-TSO
 *
 * Show / hide content based on value of a given input.
 *
 * 2022.02.23-TSO: added "dynamic".
 *
 */

conditionalJsAuto($("body"));

function conditionalJsVars(element)
{
  var target  = $(element).attr("data-conditional-target");
  var value   = $(element).attr("data-conditional-value");
  var wrapper = $(element).attr("data-conditional-wrapper");
  var type    = $(element).attr("data-conditional-type");
  var option  = $(element).attr("data-conditional");
  var method  = $(element).attr("data-conditional-method");
  var focus   = $(element).attr("data-conditional-focus");
  var trigger = $(element).attr("data-conditional-trigger");

  var not = false;
  var $target;
  if (typeof target === "undefined" || target.length < 1) {
    return false;
  }
  if (typeof method === "undefined" || method.length < 1) {
    method = "display";
  }
  focus = typeof focus !== "undefined" && focus.length > 0;
  if (typeof option !== "undefined" && option === "not") {
    not = true;
  }
  if (typeof type === "undefined" || type.length < 1) {
    if (typeof value !== "undefined") {
      type = "value";
    }
    else {
      type = "not_empty";
    }
  }
  if (typeof wrapper !== "undefined" && wrapper.length > 1) {
    $target = $(element).closest(wrapper).find(target);
  }
  else {
    $target = $(target);
  }
  if (!$target.length) {
    return false;
  }
  return {$target: $target, value: value, type: type, not: not, method: method, focus: focus, trigger: trigger};
}

function dynamicJsVars(element)
{
  var target    = $(element).attr("data-dynamic-target");
  var inputRaw  = $(element).attr("data-dynamic-input-raw");
  var lowerCase = $(element).attr("data-dynamic-lower-case");
  var useHtml   = $(element).attr("data-dynamic-html");
  var wrapper   = $(element).attr("data-dynamic-wrapper");
  var trigger   = $(element).attr("data-dynamic-trigger");

  var $target;
  if (typeof target === "undefined" || target.length < 1) {
    return false;
  }
  if (typeof wrapper !== "undefined" && wrapper.length > 1) {
    $target = $(element).closest(wrapper).find(target);
  }
  else {
    $target = $(target);
  }
  if (!$target.length) {
    return false;
  }
  return {$target: $target, inputRaw: inputRaw, lowerCase: lowerCase, useHtml: useHtml, trigger: trigger};
}

function conditionalJsIf($element, conditional)
{
  var output;

  switch (conditional.type.toLowerCase()) {
    case "radio":
      output = conditional.$target.filter("[value='" + conditional.value + "']:checked").length;
      break;
    case "length":
      output = $element.val().length >= parseInt(conditional.value);
      break;
    case "longer_than":
      output = $element.val().length > parseInt(conditional.value);
      break;
    case "shorter_than":
      output = $element.val().length < parseInt(conditional.value);
      break;
    case "check":
    case "checked":
    case "checkbox":
      output = $element.is(":checked");
      break;
    case "value":
      output = $element.val() === conditional.value;
      break;
    case "contains":
      output = $element.val().indexOf(conditional.value) !== -1;
      break;
    case "array":
      output         = false;
      var valueArray = conditional.value.split(",");
      var elementVal = $element.val();
      valueArray.forEach(function(singleValue) {
        if (elementVal === singleValue.trim()) {
          output = true;
        }
      });
      break;
    default:
    case "not_empty":
      output = $element.val().length > 0;
      break;
  }
  if (conditional.not) {
    return !output;
  }
  else {
    return output;
  }
}

function conditionalJsHide(element, conditional)
{
  switch (conditional.method) {
    case "enable":
    case "enabled":
    case "disable":
    case "disabled":
      $(element).prop("disabled", true);
      break;
    case "read-only":
    case "readonly":
      $(element).prop("readonly", true);
      break;
    case "visible":
    case "invisible":
    case "visibility":
      $(element).css({visibility: "hidden"});
      break;
    default:
      $(element).hide();
      break;
  }
}

function conditionalJsShow(element, conditional)
{
  switch (conditional.method) {
    case "enable":
    case "enabled":
    case "disable":
    case "disabled":
      $(element).prop("disabled", false);
      break;
    case "read-only":
    case "readonly":
      $(element).prop("readonly", false);
      break;
    case "visible":
    case "invisible":
    case "visibility":
      $(element).css({visibility: "visible"});
      break;
    default:
      $(element).show();
      break;
  }
  if (conditional.focus) {
    $(element).focus();
  }
}

function dynamicJsContent($element, $input, dynamic)
{
  var getDisplayText = true;
  if (typeof dynamic.inputRaw !== "undefined" && dynamic.inputRaw === "yes") {
    getDisplayText = false;
  }
  var displayText = $input.val();

  if (getDisplayText) {
    displayText = dynamicJsDisplayText($input);
  }

  if (typeof dynamic.lowerCase !== "undefined" && dynamic.lowerCase === "yes") {
    displayText = displayText.toLowerCase();
  }
  if (typeof dynamic.useHtml !== "undefined" && dynamic.useHtml === "yes") {
    $element.html(displayText);
  }
  else {
    $element.text(displayText);
  }

}

function dynamicJsDisplayText($input)
{
  if (!$input.length) {
    return "";
  }
  var value = $input.val();
  if ($input.is("select")) {

    var $option = $input.find("option[value='" + value + "']:first");
    if (!$option.length) {
      return value;
    }
    return $option.html();
  }

  if (!$input.is("[type='checkbox']") && !$input.is("[type='radio']")) {
    return value;
  }

  var inputId = $input.attr("id");
  var $label;
  if (typeof inputId !== "undefined" && inputId.length > 0) {
    $label = $("label[for='" + inputId + "']:first");
    if ($label.length) {
      return $label.html();
    }
  }
  $label = $input.closest("label");
  if ($label.length) {
    return $label.text();
  }
  return value;
}

function conditionalJsAuto($wrapper)
{
  $wrapper.find(".dynamic-content").each(function() {
    var dynamic = dynamicJsVars(this);
    if (dynamic === false) {
      return true;
    }

    var $that   = $(this);
    var trigger = dynamic.trigger || "change";
    //---- trigger
    dynamic.$target.on(trigger, function() {
      dynamicJsContent($that, $(this), dynamic);
    });
    //--- init
    dynamicJsContent($that, dynamic.$target, dynamic);
    //----
  });
  $wrapper.find(".conditional, .conditional-show").each(function() {
    var conditional = conditionalJsVars(this);
    if (conditional === false) {
      return true;
    }

    var that    = this;
    var trigger = conditional.trigger || "change";
    //---- trigger
    conditional.$target.on(trigger, function() {
      if (conditionalJsIf($(this), conditional)) {
        conditionalJsShow(that, conditional);
      }
      else {
        conditionalJsHide(that, conditional);
      }
    });
    //----init
    if (conditionalJsIf(conditional.$target, conditional)) {
      conditionalJsShow(that, conditional);
    }
    else {
      conditionalJsHide(that, conditional);
    }
    //----
  });
  $wrapper.find(".conditional-hide").each(function() {
    var conditional = conditionalJsVars(this);
    if (conditional === false) {
      return true;
    }

    var that    = this;
    var trigger = conditional.trigger || "change";
    //---- trigger
    conditional.$target.on(trigger, function() {
      if (conditionalJsIf($(this), conditional)) {
        conditionalJsHide(that, conditional);
      }
      else {
        conditionalJsShow(that, conditional);
      }
    });
    //---- init
    if (conditionalJsIf(conditional.$target, conditional)) {
      conditionalJsHide(that, conditional);
    }
    else {
      conditionalJsShow(that, conditional);
    }
    //-----
  });
}

jQuery.fn.extend({
  conditionalJsAuto: function() {
    conditionalJsAuto($(this));
  }
});

